import axios from 'axios'
import pako from 'pako'
import { DateTime } from 'luxon'


axios.defaults.headers.common['Content-Type'] = "application/json"

const ROAD_POINTS_LENGTH = 31533;

function decode(encodeData) {
  let decodedData = window.atob(encodeData);
  let charData = decodedData.split('').map(x => x.charCodeAt(0));

  let binData = new Uint8Array(charData);
  let data = pako.inflate(binData);

  return new Uint16Array(data.buffer)
}

export default {
  fetchAlarm() {
    return axios.get("/api/alarms")
    .then((res) => res.data)
  },

  fetchRadar() {
    return axios.get("/api/radar")
    .then((res) => {
      return res.data.map(r => {
        r.display = r.time.replace("T"," ").replace("+08:00","").slice(0, 16)
        return r
      })
    })
  },

  fetchSevere() {
    return axios.get("/api/severe_convection")
    .then((res) => {
      return res.data.map(r => {
        r.display = r.time.replace("T"," ").replace("+08:00","").slice(0, 16)
        return r
      })
    })
  },

  fetchRoadCond() {
    return axios.get("/api/road_condition")
    .then((res) => {
      return res.data.data.map(r => {
        r.display = r.time.replace("T"," ").replace("+08:00","").slice(0, 16)
        return r
      })
    })
  },

  fetchRoadStatus2(varType) {
    return axios.get("/api/roadtime").then((res) => {
      const initTime = DateTime.fromISO(res.data.last_updated.replace("+08:00",""))
      const length = 20;
      const steps = [...Array(length).keys()].map((index) => {
        const currentTime = initTime.plus({minutes: index * 6})
        // currentTime.toFormat(DateTime.TIME_24_SIMPLE)
        return {
          'display': currentTime.toFormat('yyyy-MM-dd HH:mm'),
          'value': index
        }
      })

      return {
        "ROAD_POINTS_LENGTH": ROAD_POINTS_LENGTH,
        "steps": steps,
        "last_updated": res.data.last_updated
      }
    }).then((ret) => {
      const url = "https://tp-api-v4-static.oss-cn-hangzhou.aliyuncs.com/vip/honda-demo/updated/"
      return axios.get(`${url}${varType}.raw.gz`, {
        responseType:'arraybuffer'
      }).then(res => {
        let binData = new Uint8Array(res.data);
        let data = pako.inflate(binData);

        ret.data = new Uint16Array(data.buffer)
        return ret
      });
    });
  },

  fetchRoadStatus(varType) {
    return axios.get("/api/road", {params: {"type": varType}})
    .then((res) => {

      const values = decode(res.data.data)
      const length = Math.min(values.length / ROAD_POINTS_LENGTH, 20)

      const initTime = DateTime.fromISO(res.data.last_updated.replace("+08:00",""))

      const steps = [...Array(length).keys()].map((index) => {
        const currentTime = initTime.plus({minutes: index * 6})
        // currentTime.toFormat(DateTime.TIME_24_SIMPLE)
        return {
          'display': currentTime.toFormat('yyyy-MM-dd HH:mm'),
          'value': index
        }
      })

      return {
        "data": values,
        "ROAD_POINTS_LENGTH": ROAD_POINTS_LENGTH,
        "steps": steps,
        "last_updated": res.data.last_updated
      }
    })
  }
}